module.exports = __webpack_public_path__ + "img/logo-menu-branco.c159c5c7.png";